export default "__VITE_ASSET__DkGavidR__"